(function () {
    'use strict';

    angular
        .module('app.completions')
        .factory('completions.dialog', completionsDialog);

    completionsDialog.$inject = ['$uibModal', 'opsIncludeVersion'];
    /* @ngInject */
    function completionsDialog($uibModal, opsIncludeVersion) {
        var service = {
            display: display
        }
        
        return service;

        function display(item) {
            var modalOptions = {
                ariaLabelledBy: "labelby",
                templateUrl: 'app/dialogs/_modalTemplateDialog.html?v=' + opsIncludeVersion,
                controller: CompletionsModalInstance,
                controllerAs: 'vm',
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            item: item,
                            includeTemplate: 'app/completions/_completions.html?v=' + opsIncludeVersion
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }
    }


    CompletionsModalInstance.$inject = ['$uibModalInstance', 'options', 'config', 'common', 'dataservice', 'completionsService'];

        /* @ngInject */
    function CompletionsModalInstance($uibModalInstance, options, config, common, dataservice, completionsService) {
        var vm = this;
        vm.isSaving = false;
        vm.item = options.item;
        vm.includeTemplate = options.includeTemplate;
        vm.okText = 'Close';
        vm.allDone = [];
        vm.ok = function () {
            $uibModalInstance.close('ok');
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.completeItem = completeItem;
        vm.title = vm.item.BookingId > 0 ? vm.item.EventName : vm.item.TaskDescription;
        vm.completionButtonClass = completionButtonClass;

        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
            }, function (error) { });
        }

        function completionButtonClass(completionTypeId) {
            var lastCompletion = completionsService.getLastCompletionForType(completionTypeId, vm.item);
            
            if (lastCompletion) {
                if (lastCompletion.CompletedAtUtc != null) {
                    return "btn btn-success";
                }
                else {
                    return "btn btn-danger";
                }
            }
            else {
                return "btn btn-danger";
            }

        }

        function completeItem(completionTypeId) {
            var completion = completionsService.getLastCompletionForType(completionTypeId, vm.item);
            var isComplete = false;
            if (completion) {
                if (completion.CompletedAtUtc == null) {
                    isComplete = true;
                }
            }
            else {
                isComplete = true;
            }
            vm.isSaving = true;
            var completionDto = {};
            completionDto.BookingId = vm.item.BookingId;
            completionDto.TaskId = vm.item.TaskId;
            completionDto.DailyLogEntryId = vm.item.DailyLogEntryId;
            completionDto.IsComplete = isComplete;
            completionDto.CompletionTypeId = completionTypeId;
            completionDto.DisplayedOn = moment(common.getMainState("mainDate")).format("YYYYMMDD");

            dataservice.saveItem('api/DailySetup/NewCompletion', completionDto).then(function (saveResult) {
                common.notifier.notify(config.events.refreshCounts);
                vm.isSaving = false;
                var savedCompletion = saveResult.data;
                //vm.item.Completions.push(savedCompletion);
                //completionsService.sort(vm.item.Completions);
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }



        function getItems() {
            var path = 'api/CompletionTypes/';

            if (vm.item.TaskId > 0) {
                path += 'GetForTask';
            }
            else if (vm.item.DailyLogEntryId && vm.item.DailyLogEntryId > 0) {
                path += 'GetForLog';
            }
            else if (vm.item.ID) {
                path += 'GetForServiceOrder';
            }
            else if (vm.item.BookingId > 0) {
                path += 'GetForBooking';
            }
            else {
                path += 'GetForLog';
            }
            return dataservice.getItems(path).then(function (response) {
                vm.completionTypes = response.data;
                    vm.allDone = vm.completionTypes.filter(function (e) {
                        return e.IsAllDoneType;
                    })
                    return vm.completionTypes;
            }, function (error) { });
        }

    }
})();
